import pixNProgress from '../shared/pixNProgress.js';
import store from '../store/index.js';

/**
 * This guard prevents the loading of the certification component when the user does not have authorization.
 */
const pixCertificationGuard = async (to, from, next) => {
  try {
    await store.dispatch('certificationModule/fetchCertificationSection');
    next();
  } catch (error) {
    store.dispatch('toastModule/error', 'Unauthorized');
    pixNProgress.forceFinish();
    next(false);
  }
};

export default pixCertificationGuard;
